import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, VStack, XImage, XText } from "IZOX/_X";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class ContactInfo extends Component {

  static propTypes = {
    info: PropsType.object
  }

  static defaultProps = {
    info: {}
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ContactInfo.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  renderNormal(){
    let {info} = this.props;
    let {contactinfo} = info ?? {};
    let {phone, whatsapp, fax, email, address} = contactinfo ?? {};
    return (
      <VStack bgColor={ColorX.CSS("Grass")} fullWidth>
        <VStack pH={240} pV={80} width={SysConfig.ContentWidth} spacing={16}>
          <HStack>
            <XText fullWidth textAlign="[" color={ColorX.CSS("pureWhite")} bold fontSize={22}>
              {LocaleX.Parse({
                EN: "Contact Information",
                TC: "聯絡資料"
              })}
            </XText>
          </HStack>
          <HStack HAlign="[">
            <HStack spacing={5} HAlign="[">
              <XImage source="/Images/Icons/svg2.svg" width={24} height={24} noResize/>
              <XText color={ColorX.CSS("pureWhite")}>{phone}</XText>
            </HStack>
            <HStack spacing={5} HAlign="[">
              <XImage source="/Images/Icons/svg3.svg" width={24} height={24} noResize/>
              <XText color={ColorX.CSS("pureWhite")}>{whatsapp}</XText>
            </HStack>
            <HStack spacing={5} HAlign="[">
              <XImage source="/Images/Icons/svg4.svg" width={24} height={24} noResize/>
              <XText color={ColorX.CSS("pureWhite")}>{fax}</XText>
            </HStack>
            <HStack spacing={5} HAlign="[">
              <XImage source="/Images/Icons/svg5.svg" width={24} height={24} noResize/>
              <XText color={ColorX.CSS("pureWhite")}>{email}</XText>
            </HStack>
          </HStack>
          <HStack spacing={5} HAlign="[">
            <XImage source="/Images/Icons/svg1.svg" width={24} height={24} noResize/>
            <XText color={ColorX.CSS("pureWhite")}>{LocaleX.Parse(address)}</XText>
          </HStack>
        </VStack>
      </VStack>
    );
  }

  renderMobile(){
    let {info} = this.props;
    let {contactinfo} = info ?? {};
    let {phone, whatsapp, fax, email, address} = contactinfo ?? {};
    let iconSize = 40;
    return (
      <VStack bgColor={ColorX.CSS("Grass")} fullWidth>
        <VStack pH={40} pV={40} fullWidth spacing={16}>
          <HStack HAlign="|">
            <XText color={ColorX.CSS("pureWhite")} bold fontSize={40}>
              {LocaleX.Parse({
                EN: "Contact Information",
                TC: "聯絡資料"
              })}
            </XText>
          </HStack>
          <VStack fullWidth spacing={20}>
            <HStack>
              <HStack spacing={15} HAlign="[">
                <XImage source="/Images/Icons/svg2.svg" width={iconSize} height={iconSize} noResize/>
                <XText color={ColorX.CSS("pureWhite")}>{phone}</XText>
              </HStack>
              <HStack spacing={15} HAlign="[">
                <XImage source="/Images/Icons/svg3.svg" width={iconSize} height={iconSize} noResize/>
                <XText color={ColorX.CSS("pureWhite")}>{whatsapp}</XText>
              </HStack>
            </HStack>
            <HStack>
              <HStack spacing={15} HAlign="[">
                <XImage source="/Images/Icons/svg4.svg" width={iconSize} height={iconSize} noResize/>
                <XText color={ColorX.CSS("pureWhite")}>{fax}</XText>
              </HStack>
              <HStack spacing={15} HAlign="[">
                <XImage source="/Images/Icons/svg5.svg" width={iconSize} height={iconSize} noResize/>
                <XText color={ColorX.CSS("pureWhite")}>{email}</XText>
              </HStack>
            </HStack>
          </VStack>
          <HStack spacing={15} HAlign="[">
            <XImage source="/Images/Icons/svg1.svg" width={iconSize} height={iconSize} noResize/>
            <XText color={ColorX.CSS("pureWhite")}>{LocaleX.Parse(address)}</XText>
          </HStack>
        </VStack>
      </VStack>
    );
  }

  render(){
    return ResponsiveX.Split({
      0: () => this.renderMobile(),
      [SysConfig.WebUIWidth]: () => this.renderNormal()
    });
  }

  

}

export default observer(ContactInfo);
